import { createAPI } from "./apisServer";

const apiServer = createAPI("webhook");

const reqControlServer = {
	parar: async function (nome) {
		return apiServer
			.post(`webhook/servicos/${nome}/parar`)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqControlServer;
